export default {
  activeMarketsLabel: {
    id: 'bo_seller.options.shipping.manage_weekend_delivery.active_markets.label',
    defaultMessage: 'Active markets:',
  },
  activeMarketsTag: {
    id: 'bo_seller.options.shipping.manage_weekend_delivery.active_markets.tag',
    defaultMessage: '{weekday}: {activeMarkets}/{totalMarkets}',
  },
}
